// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation-module__navigation--UVxEi","sections":"Navigation-module__sections--k6YqR","section":"Navigation-module__section--DZPLs"};